/*global ym*/
import Cookie from "js-cookie"

import {
    IS_PRODUCTION,
    ANALYTIC_DEBUG_SHOW_LOG,
    YANDEX_METRIKA_COUNTER_ID,
} from "../env-management"
import { isBrowser } from "../infrastructure/ssg-utils"

type Event = ym.Event
type Options = ym.HitOptions<unknown>

export function getYmClientId() {
    return Cookie.get("_ym_uid")
}

const ymQueue: Array<() => void> = []

export function ymSendHit(url: string, options?: Options) {
    const ymFn: Event | undefined = window.ym

    if (!ymFn) {
        ymQueue.push(() => ymSendHit(url, options))
        if (ANALYTIC_DEBUG_SHOW_LOG) {
            console.log(
                `Y.Metrika not ready, queued hit: ${JSON.stringify(url)}, ${JSON.stringify(options ?? {}, null, 2)}`
            )
        }
        return
    }

    if (IS_PRODUCTION) {
        ymFn(YANDEX_METRIKA_COUNTER_ID as unknown as number, "hit", url, options)
    } else if (ANALYTIC_DEBUG_SHOW_LOG) {
        console.log(
            `ym('${YANDEX_METRIKA_COUNTER_ID}', 'hit', ${JSON.stringify(url)}, ${JSON.stringify(options ?? {}, null, 2)})`
        )
    }
}

type GoalParams = Record<string, unknown>

export function ymReachGoal(target: string, params?: GoalParams) {
    const ymFn: Event | undefined = window.ym

    if (!ymFn) {
        ymQueue.push(() => ymReachGoal(target, params))
        if (ANALYTIC_DEBUG_SHOW_LOG) {
            console.log(
                `Y.Metrika not ready, queued reachGoal: ${JSON.stringify(target)}, ${JSON.stringify(params ?? {}, null, 2)}`
            )
        }
        return
    }

    if (IS_PRODUCTION) {
        ymFn(YANDEX_METRIKA_COUNTER_ID as unknown as number, "reachGoal", target, params)
    } else if (ANALYTIC_DEBUG_SHOW_LOG) {
        console.log(
            `ym('${YANDEX_METRIKA_COUNTER_ID}', 'reachGoal', ${JSON.stringify(target)}, ${JSON.stringify(params ?? {}, null, 2)})`
        )
    }
}

if (isBrowser()) {
    document.addEventListener(`yacounter${YANDEX_METRIKA_COUNTER_ID}inited`, function () {
        if (ANALYTIC_DEBUG_SHOW_LOG) {
            console.log(`Y.Metrika counter ready, executing ${ymQueue.length} queue tasks`)
        }
        ymQueue.forEach((action) => action())
        if (ANALYTIC_DEBUG_SHOW_LOG) {
            console.log("Y.Metrika queue is fully executed")
        }
    })
}
